import { Component, OnInit } from '@angular/core';
import { environment } from "src/environments/environment";

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  appVersion = environment.version;
  isProduction = environment.production;
  surveyUrl = "https://surveys.vch.ca/Survey.aspx?s=e21504acdd5e441589446d440ae9ae38";

  ngOnInit() {
  }

  getCurrentDate() {
    return new Date().getFullYear();
  }
}